import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import parsePostContent from '../../common/helpers/parsePostContent';
/**
 * System post for a battle closed blame-free, with no winner/loser — either
 * auto-closed after 5 days with no activity before it ever really started
 * (open lobby nobody joined, or an unfinished first turn — see
 * ExpireBattlesCommand::closeStaleUnstartedBattles()), or force-closed
 * on demand from the admin panel (CloseAdminBattleController::
 * forceCloseBattle()). Type: arenaBattleClosed. Lock icon + neutral color,
 * same title either way — but the subtitle only fits the auto-sweep case
 * ("never really started"), which would be actively wrong for a battle an
 * admin just force-closed mid-fight, so it only renders when
 * SystemPostFactory::createClosedPost() was called with $auto = true (see
 * that method's docblock).
 */
export default class ArenaBattleClosedPost extends Component {
  view() {
    const data = parsePostContent(this.attrs.post.content());
    return m("div", {
      className: "ArenaFinalPost ArenaFinalPost--closed EventPost"
    }, m("div", {
      className: "ArenaFinalPost-icon"
    }, m("i", {
      className: "fas fa-lock"
    })), m("div", {
      className: "ArenaFinalPost-body"
    }, m("div", {
      className: "ArenaFinalPost-title"
    }, app.translator.trans('forumaker-arena.forum.battle_closed.title')), data?.auto && m("div", {
      className: "ArenaFinalPost-subtitle"
    }, app.translator.trans('forumaker-arena.forum.battle_closed.subtitle'))));
  }
}
flarum.reg.add('forumaker-arena', 'forum/components/ArenaBattleClosedPost', ArenaBattleClosedPost);